type Props = {
  imageUrl: string;
  name: string;
  onClick?: () => void;
};

export default function LinkedAccountServiceCard({ imageUrl, name, onClick }: Props) {
  return (
    <div
      className="relative h-[151px] w-[270px] cursor-pointer rounded bg-white shadow-layer1 hover:opacity-60"
      onClick={onClick}
    >
      <div className="absolute top-[20px] left-[93px] size-[84px]">
        <img src={imageUrl} alt="" width={84} height={84} className="object-contain" />
      </div>
      <p className="absolute inset-x-0 bottom-sm text-center text-base font-bold">{name}</p>
    </div>
  );
}
